import { apiCall } from "./api";

export const getAccess = async (workspaceId) => {
  return apiCall("/api/v1/workspace-service-access/" + workspaceId, {
    // return apiCall("/api/v1/workspace-service-access", {
    credentials: "include",
  });
};

export const addAccess = async (workspaceId, allowedServices = []) => {
  return apiCall(`/api/v1/workspace-service-access`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      workspaceId: workspaceId,
      allowedServices: allowedServices,
    }),
    credentials: "include",
  });
};

export const updateAccess = async (id, workspaceId, allowedServices = []) => {
  return apiCall(`/api/v1/workspace-service-access/${id}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      workspaceId: workspaceId,
      allowedServices: allowedServices,
    }),
    credentials: "include",
  });
};
